import { capitalise } from "@wisr/common";

export const capitaliseName = (name: string) => {
  const isUpperCase = name === name.toUpperCase();
  return isUpperCase ? capitalise(name.toLowerCase()) : capitalise(name);
};
